<div mat-dialog-content class="modal-container" [hidden]="switchingToLogin">
  <div class="modal-header">
    <button
      *ngIf="currentStep !== 0 && currentStep !== 6"
      type="button"
      class="back-arrow"
      (click)="goBack()"
    >
      <i class="fa-solid fa-arrow-left"></i>
    </button>

    <button (click)="gocloseModal()" type="button" class="close">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <!-- Step 0: Welcome / Inicio de sesión -->
  <ng-container *ngIf="currentStep === 0">
    <app-sign-in-step-welcome
      [googleRequest]="googleRequest"
      (goToStep)="goToStep($event)"
      (signUpWithFB)="signUpWithFB()"
      (goToLegal)="goToLegal()"
      (openLoginModal)="openLoginModal()"
    ></app-sign-in-step-welcome>
  </ng-container>

  <form
    (ngSubmit)="register()"
    [formGroup]="registerForm"
    id="form_signin_register"
  >
    <!-- Step 1: Registro (nombre, email, contraseña) -->
    <ng-container *ngIf="currentStep === 1">
      <app-sign-in-step-register
        [registerForm]="registerForm"
        [showPassword]="showPassword"
        [hasMinLength]="hasMinLength"
        [hasUpperCase]="hasUpperCase"
        [hasLowerCase]="hasLowerCase"
        [hasNumber]="hasNumber"
        [isSocialSignup]="isSocialSignup"
        [emailAlreadyExists]="emailAlreadyExists"
        [checkingEmail]="checkingEmail"
        (goToStep)="goToStep($event)"
        (continueClicked)="onRegisterStepContinue()"
        (togglePasswordVisibility)="togglePasswordVisibility()"
        (goToLegal)="goToLegal()"
        (openLoginModal)="openLoginModal()"
      ></app-sign-in-step-register>
    </ng-container>

    <!-- Step 2: Sobre ti (tipo usuario, teléfono, empresa) -->
    <ng-container *ngIf="currentStep === 2">
      <app-sign-in-step-about
        [registerForm]="registerForm"
        [userTypes]="userTypes"
        [userTypeSelected]="userTypeSelected"
        [isSeller]="isSeller"
        (selectType)="selectType($event)"
        (onRegisterTypeChange)="onRegisterTypeChange()"
        (goToStep)="goToStep($event)"
        (submit)="register()"
      ></app-sign-in-step-about>
    </ng-container>

    <!-- Step 3: Encuesta parte 1 -->
    <ng-container *ngIf="currentStep === 3">
      <app-sign-in-step-survey-1
        [surveyObjective]="surveyObjective"
        [surveyRisk]="surveyRisk"
        [surveyInvolvement]="surveyInvolvement"
        (surveyObjectiveChange)="surveyObjective = $event"
        (surveyRiskChange)="surveyRisk = $event"
        (surveyInvolvementChange)="surveyInvolvement = $event"
        (goToStep)="goToStep($event)"
      ></app-sign-in-step-survey-1>
    </ng-container>

    <!-- Step 4: Encuesta parte 2 -->
    <ng-container *ngIf="currentStep === 4">
      <app-sign-in-step-survey-2
        [surveyDecision]="surveyDecision"
        [surveyPhrase]="surveyPhrase"
        (surveyDecisionChange)="surveyDecision = $event"
        (surveyPhraseChange)="surveyPhrase = $event"
        (goToStep)="goToStep($event)"
      ></app-sign-in-step-survey-2>
    </ng-container>

    <!-- Step 5: Preferencias -->
    <ng-container *ngIf="currentStep === 5">
      <app-sign-in-step-preferences
        [registerForm]="registerForm"
        [prefZones]="prefZones"
        [prefSelectedZone]="prefSelectedZone"
        [prefMinTicket]="prefMinTicket"
        [prefMaxTicket]="prefMaxTicket"
        [prefAssetTypes]="prefAssetTypes"
        [prefPropertiesCount]="prefPropertiesCount"
        [prefProblematic]="prefProblematic"
        [isLoading]="isRegistering"
        (prefZonesChange)="prefZones = $event"
        (prefSelectedZoneChange)="prefSelectedZone = $event"
        (prefMinTicketChange)="prefMinTicket = $event"
        (prefMaxTicketChange)="prefMaxTicket = $event"
        (prefPropertiesCountChange)="prefPropertiesCount = $event"
        (prefProblematicChange)="prefProblematic = $event"
        (toggleAssetType)="toggleAssetType($event)"
        (submit)="register()"
      ></app-sign-in-step-preferences>
    </ng-container>

    <!-- Step 6: Éxito -->
    <ng-container *ngIf="currentStep === 6">
      <app-sign-in-step-success
        [isSocialSignup]="isSocialSignup"
      ></app-sign-in-step-success>
    </ng-container>

    <!-- Step 7: Contacto vendedor - Localización -->
    <ng-container
      *ngIf="currentStep === 7 && myContactForm && localizationForm"
    >
      <app-sign-in-step-saler-localization
        [localizationForm]="localizationForm"
        [submited]="submited1Saler"
        [roadTypes]="roadTypes"
        [locations]="locations"
        [provinces]="provinces"
        [countries]="salerCountries"
        [language]="salerLanguage"
        (goToStep)="goToStep($event)"
      ></app-sign-in-step-saler-localization>
    </ng-container>

    <!-- Step 8: Contacto vendedor - Propiedad -->
    <ng-container *ngIf="currentStep === 8 && myContactForm && propertyForm">
      <app-sign-in-step-saler-property
        [propertyForm]="propertyForm"
        [submited]="submited2Saler"
        [propertyTypes]="propertyTypes"
        [language]="salerLanguage"
        [isLoadingSubmit]="isRegistering"
        (ocupationToggle)="salerOcupationToggle()"
        (submit)="register()"
      ></app-sign-in-step-saler-property>
    </ng-container>
  </form>
</div>
